"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  pleaseEnter: '请输入内容',
  ebSysAccount: {
    invalidEmail: '邮箱格式不正确'
  }
};